import React from 'react';
import { Box } from '@99designs/emu';
import { JobCard, JobCardProps } from './JobCard';

interface JobListingsPageWithJobsProps {
    items: JobCardProps['jobForDesigner'][];
    pagination: React.ReactNode;
    refetch?: () => void;
}
export function JobListings({ items, pagination, refetch }: JobListingsPageWithJobsProps) {
    return (
        <>
            <Box>
                {items.map((item) => (
                    <JobCard
                        key={item.job.id}
                        jobForDesigner={item}
                        onCtaActionCompleted={refetch}
                    />
                ))}
            </Box>
            {pagination}
        </>
    );
}
